import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import * as U from "../../style/StyleComponentUtility";
import { SearchPostButton } from "../../style/StyleComponentUtility";
import SelectProductComp from "./SelectProductComp";
import DaumPostCode from "../Utility/DaumPostCode";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { removeWhitespacePhone, validatePhone, get_today_plus_object, checkAvailableAreasWithinWeek, get_today_object } from "../../Validation";
import { get_estimate_price, get_ablack_holiday, insert_reservation, insert_reservation_with_removal, send_message } from "../../Axios";
import { eliminate_hyphen, generate_random_code, update_nav } from "../../Util";
import { useDispatch } from "react-redux";
import {
  reduxChangeReservationApproveCert,
  reduxChangeReservationClientName,
  reduxChangeReservationClientPhoneNumber,
  reduxChangeReservationClientRequest,
  reduxChangeReservationDate,
  reduxChangeReservationDirectContactManager,
  reduxChangeReservationManagerPhoneNumber,
  reduxChangeReservationSpace,
  reduxChangeReservationSquareMeter,
  reduxChangeReservationTime,
  reduxChangeInstallPostcode,
  reduxChangeInstallReservationDate,
  reduxChangeInstallReservationTime,
  reduxResetReservation
} from "../../redux/ReservationSlice";
import { reduxOffSpinner, reduxOnSpinner } from "../../redux/CommonSlice";
import { useNavigate } from "react-router-dom";
import theme from "../../style/theme";
import { availableAreasWithinWeek, MAX_DAYS_MAJOR_AREA, MAX_DAYS_OTHER_AREA, MIN_DAYS_MAJOR_AREA, MIN_DAYS_OTHER_AREA } from "../../Variable";

const mainBlack = theme.colors.mainBlack;
const mainWhite = theme.colors.mainWhite;

interface IndividualProduct {
  color_name: string;
  construction_reservation_pay: number;
  product_kor_name: string;
  quantity: number;
};

const Reservation: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [exPhotoList, setExPhotoList] = useState<File[]>([]);
  const [exPreviewList, setExPreviewList] = useState<string[]>([]);
  const customerData = useSelector((state: RootState) => state.customerData);
  const reservationData = useSelector((state: RootState) => state.reservationData);
  const [showReservationReview, setShowReservationReview] = useState<boolean>(false);

  const [modal, setModal] = useState<boolean>(false);

  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [renderTotalPrice, setRenderTotalPrice] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [individualPriceList, setIndividualPriceList] = useState<IndividualProduct[]>([]);

  const customerManagerPhoneNumber = useSelector((state: RootState) => state.reservationData.reservation_manager_phone_number);
  const clientPhoneNumber = useSelector((state: RootState) => state.reservationData.reservation_client_phone_number);
  const clientName = useSelector((state: RootState) => state.reservationData.reservation_client_name);
  const clientRequest = useSelector((state: RootState) => state.reservationData.reservation_client_request);
  const clientScheduledDate = useSelector((state: RootState) => state.reservationData.reservation_date);
  const clientReservationTime = useSelector((state: RootState) => state.reservationData.reservation_time); // 1 : 오전, 2 : 오후, 3 : 종일
  const installerCheck = useSelector((state: RootState) => state.reservationData.reservation_direct_contact_manager);
  const squareMeter = useSelector((state: RootState) => state.reservationData.reservation_square_meter);
  const space = useSelector((state: RootState) => state.reservationData.reservation_space);

  const [certificationTimer, setCertificationTimer] = useState<boolean>(false);
  const [countdown, setCountdown] = useState<number>(600);
  const [rederCountdown, setRenderCountdown] = useState<string>("");
  const [certificationCode, setCertificationCode] = useState<string>("AAAAAA");
  const [noticeCertification, setNoticeCertification] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const approveCert = useSelector((state: RootState) => state.reservationData.approve_cert);

  const [directPhotoList, setDirectPhotoList] = useState<File[]>([]);
  const [propsPriceList, setPropsPriceList] = useState<number[]>([]);
  const [installPriceList, setInstallPriceList] = useState<number[]>([]);
  const [ablackHolidayList, setAblackHolidayList] = useState<string[]>([]);

  const [availableMinimumDate, setAvailableMinimumDate] = useState<string>(get_today_plus_object(MIN_DAYS_OTHER_AREA).year_month_day);
  const [availableMaximumDate, setAvailableMaximumDate] = useState<string>(get_today_plus_object(MAX_DAYS_OTHER_AREA).year_month_day);

  // 탈거+시공 동시 진행 시 시공지(install) 주소 기준 시공 희망일 최소/최대일
  const [availableInstallMinimumDate, setAvailableInstallMinimumDate] = useState<string>(get_today_plus_object(MIN_DAYS_OTHER_AREA).year_month_day);
  const [availableInstallMaximumDate, setAvailableInstallMaximumDate] = useState<string>(get_today_plus_object(MAX_DAYS_OTHER_AREA).year_month_day);

  const [constructionAgreement, setConstructionAgreement] = useState<boolean>(false);

  // 탈거+시공 동시 진행 여부 (탈거탭 + 토글 ON)
  const withRemoval = reservationData.reservation_division === 4 && reservationData.reservation_with_removal === 1;
  // 시공 주소·날짜를 탈거와 동일하게 사용하는지 여부
  const [sameAsRemoval, setSameAsRemoval] = useState<boolean>(false);

  // const [certificationManager, setCertificationManager] = useState<boolean>(false);
  // const [certificationClient, setCertificationClient] = useState<boolean>(false);

  useEffect(() => {
    if (withRemoval) {
      if (!reservationData.reservation_high_status || !customerData.customer_ablack_rate) return;
      let cancelled = false;
      const removalProducts = reservationData.selected_product;
      const installProducts = reservationData.install_selected_product;
      Promise.all([
        removalProducts.length ? get_estimate_price(
          reservationData.reservation_division,
          reservationData.reservation_high_status,
          removalProducts,
          customerData.customer_ablack_rate,
          reservationData.postcode_3.address,
          reservationData.postcode_4.address,
          0
        ) : Promise.resolve([]),
        installProducts.length ? get_estimate_price(
          reservationData.reservation_division,
          reservationData.reservation_high_status,
          installProducts,
          customerData.customer_ablack_rate,
          reservationData.install_postcode.address,
          reservationData.postcode_4.address,
          0
        ) : Promise.resolve([])
      ]).then(([removalResult, installResult]) => {
        if (cancelled) return;
        const removalItems: IndividualProduct[] = removalResult.map((rows: IndividualProduct[]) => ({
          ...rows[0],
          construction_reservation_pay: Math.floor(rows[0].construction_reservation_pay * 0.5)
        }));
        const installItems: IndividualProduct[] = installResult.map((rows: IndividualProduct[]) => rows[0]);
        const removalPrices = removalItems.map(item => item.construction_reservation_pay);
        const installPrices = installItems.map(item => item.construction_reservation_pay);
        setPropsPriceList(removalPrices);
        setInstallPriceList(installPrices);
        setIndividualPriceList([...removalItems, ...installItems]);
        setTotalPrice([...removalPrices, ...installPrices].reduce((sum, price) => sum + price, 0));
      });
      return () => { cancelled = true; };
    }
    if (!reservationData.reservation_division) return;
    if (!reservationData.reservation_high_status) return;
    if (!reservationData.selected_product.length) {
      setTotalPrice(0);
      setIndividualPriceList([]);
      return;
    }
    if (!customerData.customer_ablack_rate) return;
    if (reservationData.reservation_division === 3) { if (!reservationData.postcode_3.address || !reservationData.postcode_4.address) return };
    let arr = [...reservationData.selected_product];
    // 견적 계산할 때 배열에 brand_ID 99 찾아서 빼기
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].brand_ID === 99) {
        arr.splice(i, 1);
      };
    };
    if (!arr.length) {
      setTotalPrice(0);
      setIndividualPriceList([]);
      return;
    };

    get_estimate_price(
      reservationData.reservation_division,
      reservationData.reservation_high_status,
      arr,
      customerData.customer_ablack_rate,
      reservationData.postcode_3.address,
      reservationData.postcode_4.address,
      reservationData.reservation_with_removal
    ).then(result => {
      let list = [];
      let list_price = [];
      let sum = 0;
      for (let i = 0; i < result.length; i++) {
        const item = result[i][0];
        const obj: IndividualProduct = {
          color_name: item.color_name,
          construction_reservation_pay: item.construction_reservation_pay,
          product_kor_name: item.product_kor_name,
          quantity: item.quantity
        };
        const price = item.construction_reservation_pay;
        list_price.push(price);
        sum += price;
        list.push(obj);
      };
      setPropsPriceList(list_price);
      setIndividualPriceList(list);
      setTotalPrice(sum);
    })
  }, [customerData.customer_ablack_rate, reservationData.postcode_3.address, reservationData.postcode_4.address, reservationData.reservation_division, reservationData.reservation_with_removal, reservationData.reservation_high_status, reservationData.selected_product, reservationData.install_selected_product, reservationData.install_postcode.address, withRemoval]);

  useEffect(() => {
    let num: number = totalPrice;
    setRenderTotalPrice(num.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","));
  }, [totalPrice]);

  // 인스톨러 직접연락 check & 앰비언스에 출고요청 check TODO: 체크를 다시 토글했을 때 인증 절차를 어떻게 할건지 질문
  const handleInstallerCheck = () => {
    if (approveCert) return;
    dispatch(reduxChangeReservationDirectContactManager(!installerCheck));
    setCertificationTimer(false); // 타이머 초기화
    setNoticeCertification("");
  };

  useEffect(() => {
    if(modal) {
        document.body.classList.add('on-modal-back');
    } else {
        document.body.classList.remove('on-modal-back');
    }
}, [modal]);

  useEffect(() => {
    if (installerCheck) {
      dispatch(reduxChangeReservationClientPhoneNumber(""));
    } else {
      dispatch(reduxChangeReservationManagerPhoneNumber(""));
    }
  }, [dispatch, installerCheck]);

  // "동일하게"는 탈거지 주소 복붙용. 복사 후 시공지(또는 탈거지) 주소가 달라지면 체크 자동 해제
  useEffect(() => {
    if (!withRemoval || !sameAsRemoval) return;
    const isSame =
      reservationData.install_postcode.zip_code === reservationData.postcode_3.zip_code &&
      reservationData.install_postcode.address === reservationData.postcode_3.address &&
      reservationData.install_postcode.detail_address === reservationData.postcode_3.detail_address;
    if (!isSame) setSameAsRemoval(false);
  }, [withRemoval, sameAsRemoval, reservationData.install_postcode, reservationData.postcode_3]);

  // 탈거+시공 동시 진행이 해제되면 "동일하게" 체크도 초기화
  useEffect(() => {
    if (!withRemoval) setSameAsRemoval(false);
  }, [withRemoval]);


  const handleReservationDateByArea = (min_number: number, max_number: number) => {
    const min_date = get_today_plus_object(min_number).year_month_day;
    const max_date = get_today_plus_object(max_number).year_month_day;
    dispatch(reduxChangeReservationDate(min_date));
    setAvailableMinimumDate(min_date);
    setAvailableMaximumDate(max_date);
  };

  const handleInstallReservationDateByArea = (min_number: number, max_number: number) => {
    const min_date = get_today_plus_object(min_number).year_month_day;
    const max_date = get_today_plus_object(max_number).year_month_day;
    dispatch(reduxChangeInstallReservationDate(min_date));
    setAvailableInstallMinimumDate(min_date);
    setAvailableInstallMaximumDate(max_date);
  };

  useEffect(() => {
    // reservation_division 3 이면 이전설치
    if (reservationData.reservation_division === 3 ) {
      if (reservationData.postcode_3.sido === reservationData.postcode_4.sido) {
        if (checkAvailableAreasWithinWeek(reservationData.postcode_3.sido)) {
          handleReservationDateByArea(MIN_DAYS_MAJOR_AREA, MAX_DAYS_MAJOR_AREA);
        } else {
          handleReservationDateByArea(MIN_DAYS_OTHER_AREA, MAX_DAYS_OTHER_AREA);
        }
      } else {
        handleReservationDateByArea(MIN_DAYS_OTHER_AREA, MAX_DAYS_OTHER_AREA);
      }
    } else {
      if (checkAvailableAreasWithinWeek(reservationData.postcode_3.sido)) {
        handleReservationDateByArea(MIN_DAYS_MAJOR_AREA, MAX_DAYS_MAJOR_AREA);
      } else {
        handleReservationDateByArea(MIN_DAYS_OTHER_AREA, MAX_DAYS_OTHER_AREA);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationData.postcode_3, reservationData.postcode_4, reservationData.reservation_division]);

  // 탈거+시공 동시 진행 시 시공지(install) 주소 기준으로 시공 희망일 최소/최대일 계산
  useEffect(() => {
    if (!withRemoval) return;
    if (checkAvailableAreasWithinWeek(reservationData.install_postcode.sido)) {
      handleInstallReservationDateByArea(MIN_DAYS_MAJOR_AREA, MAX_DAYS_MAJOR_AREA);
    } else {
      handleInstallReservationDateByArea(MIN_DAYS_OTHER_AREA, MAX_DAYS_OTHER_AREA);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationData.install_postcode, withRemoval]);

  // 인증번호 발송 요청 1 : 기업 담당자 번호, 2 : 고객 번호
  const requestSendMobileMessage = () => {
    if (approveCert) return;
    let phone = "";
    if (installerCheck) {
      if (!validatePhone(customerManagerPhoneNumber)) {
        dispatch(reduxChangeReservationManagerPhoneNumber(""));
        alert('전화번호를 정확히 입력해주세요.');
        return
      }
      phone = customerManagerPhoneNumber;
    } else {
      if (!validatePhone(clientPhoneNumber)) {
        dispatch(reduxChangeReservationClientPhoneNumber(""));
        alert('전화번호를 정확히 입력해주세요.');
        return
      }
      phone = clientPhoneNumber;
    };
    dispatch(reduxChangeReservationApproveCert(false));
    const phone_number = eliminate_hyphen(phone);
    const random_number = generate_random_code(6);
    setCertificationCode(random_number);
    const message_data = `앰비언스 인증 번호 : [${random_number}] 10분 이내에 입력해주세요.`;
    send_message(phone_number, 1, message_data).then(result => {
      if (result === 1) {
        alert('인증번호가 발송 되었습니다.');
        setCertificationTimer(true);
        setCountdown(600);
      } else {
        alert('인증번호 발송을 실패 했습니다. 다시 시도하거나 문의하여 주세요.');
      }
    });
  };

  // certificationTimer true 나 false 됐을 때 처리 해 줄 것
  useEffect(() => {
    let timer: any;
    if (certificationTimer) {
      timer = setInterval(handleClock, 1000);
    } else {
      clearInterval(timer);
    };
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificationTimer]);

  const handleClock = () => {
    setCountdown(props => props - 1);
  };

  // countdown mm : ss 형태로 변환해주고 1미만일 때 카운트 종료하고 초기화
  useEffect(() => {
    if (countdown < 1) {
      setCertificationTimer(false);
      setCountdown(600);
      return;
    }
    let min = Math.floor(countdown / 60);
    let sec = (countdown % 60);
    setRenderCountdown(`${min.toString()} : ${sec.toString()}`);
  }, [countdown]);

  // 인증확인하고 승인하기 FIXME: 승인하는건 Redux에 담는게 나을 듯?
  const checkCertification = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length === 6 && certificationTimer) {
      if (e.target.value === certificationCode) {
        dispatch(reduxChangeReservationApproveCert(true));
      } else {
        setNoticeCertification("인증번호가 일치하지 않습니다.");
      }
    }
  };

  useEffect(() => {
    if (approveCert) {
      setNoticeCertification("인증되었습니다.");
      setCertificationTimer(false);
    }
  }, [approveCert]);

  // 사진 추가시 배열에 추가
  const insertFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      let list = [...exPhotoList];
      list.push(file);
      setExPhotoList(list);
    }
  };

  // 사진 삭제시 해당 index 배열에서 삭제
  const removeFile = (idx: number) => {
    let list = [...exPhotoList];
    list.splice(idx, 1);
    setExPhotoList(list);
  };

  // 배열의 값이 변할 때 마다 새로 배열 짜서 순서대로 화면에 표시
  useEffect(() => {
    let list = [];
    for (let i = 0; i < exPhotoList.length; i++) {
      const objectUrl = URL.createObjectURL(exPhotoList[i]);
      list.push(objectUrl);
    }
    setExPreviewList(list);
  }, [exPhotoList]);

  useEffect(() => {
    get_ablack_holiday().then(result => {
      const holidayDates = result.map((item: { ablack_holiday_date: any; }) => item.ablack_holiday_date);
      setAblackHolidayList(holidayDates);
    })
  }, []);

  const handleReservationTime = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) return;

    const target = e.target as HTMLElement;
    const value = Number(target.getAttribute('data-value'));
    dispatch(reduxChangeReservationTime(value));
  };

  // 탈거+시공 동시 진행 시 시공 희망 시간대 선택
  const handleInstallReservationTime = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) return;

    const target = e.target as HTMLElement;
    const value = Number(target.getAttribute('data-value'));
    dispatch(reduxChangeInstallReservationTime(value));
  };

  const handleCheckReservation = () => {
    // 포인트 잔액 확인 (최우선 검증). 단, 탈거+시공 동시 진행은 결제 동시 미지원이므로 잔액 검증 제외
    if (!withRemoval && Number(customerData.customer_point) < totalPrice) {
      return alert(`보유 AP가 부족합니다.\n현재 보유: ${Number(customerData.customer_point).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}AP\n필요 금액: ${renderTotalPrice}AP`);
    }

    if (
      (reservationData.reservation_division === 1 || withRemoval) &&
      reservationData.product_consumption_status === 1 &&
      reservationData.construction_reservation_expected_date === ''
    ) return alert('제품 미소지일 경우에는 제품 도착 예정일을 필수로 입력하셔야 합니다.');

    if (!reservationData.reservation_division) return alert('신청할 서비스를 선택하세요.');
    if (!reservationData.selected_product.length) return alert(withRemoval ? '탈거할 제품을 선택해주세요.' : '시공을 원하시는 제품을 선택해주세요.');
    if (withRemoval && !reservationData.install_selected_product.length) return alert(reservationData.product_consumption_status === 2 ? '출고요청할 판매 건을 선택해주세요.' : '시공할 제품을 선택해주세요.');
    for (const item of reservationData.selected_product) {
      if (item.brand_ID === 99) {
        if (item.quantity !== directPhotoList.length) return alert('직접입력하신 제품은 수량별로 사진이 반드시 필요합니다.');
      }
    };
    if (!reservationData.reservation_high_status) return alert('시공을 신청하실 천장 높이를 선택해주세요.');
    if (!clientName.trim()) return alert('고객명을 입력해주세요.');
    if (installerCheck) {
      if (!customerManagerPhoneNumber.trim()) return alert('담당자 전화번호를 입력해주세요.');
    } else {
      if (!clientPhoneNumber) return alert('고객 전화번호를 입력해주세요.');
    }
    if(!approveCert) return alert('전화번호 인증을 완료해주세요.');
    if (!reservationData.postcode_3.address) return alert('주소를 입력해주세요.');
    if (!reservationData.postcode_3.detail_address) return alert("상세주소를 입력해주세요.");
    if (reservationData.reservation_division === 3) {
      if (!reservationData.postcode_3.address || !reservationData.postcode_4.address) return alert('기존 주소와 시공할 주소를 모두 입력해 주세요.');
      if (!reservationData.postcode_3.detail_address || !reservationData.postcode_4.detail_address) return alert('상세주소를 입력해주세요.');
    };
    if (!reservationData.reservation_square_meter) return alert("전체 평수를 선택해주세요.");
    if (!reservationData.reservation_space) return alert("설치장소를 선택해주세요.");
    if (clientRequest.length < 20) return alert("요청사항을 20자 이상 작성해주세요.");
    if (exPhotoList.length < 2) return alert("현장사진을 최소 2장이상 추가해주세요.");
    if (!reservationData.reservation_date.trim()) return alert('시공 희망일자을 입력해주세요.');
    if (reservationData.reservation_date < get_today_object().year_month_day) return alert('오늘보다 이전 날자는 등록하실 수 없습니다.');
    if (!reservationData.reservation_time) return alert('시공 시간대를 선택해주세요.');

    // 탈거+시공 동시 진행 시 시공지 주소·희망일·시간대 검증
    if (withRemoval) {
      if (!reservationData.install_postcode.address) return alert('시공지 주소를 입력해주세요.');
      if (!reservationData.install_postcode.detail_address) return alert('시공지 상세주소를 입력해주세요.');
      if (!reservationData.install_reservation_date.trim()) return alert('시공 희망일자을 입력해주세요.');
      if (reservationData.install_reservation_date < get_today_object().year_month_day) return alert('오늘보다 이전 날자는 등록하실 수 없습니다.');
      if (!reservationData.install_reservation_time) return alert('시공 시간대를 선택해주세요.');
    }

    setShowReservationReview(true);
  };

  const insertReservation = () => {
    dispatch(reduxOnSpinner("잠시만 기다려주세요."));
    let phone_number = "";
    if (installerCheck) {
      phone_number = reservationData.reservation_manager_phone_number;
    } else {
      phone_number = reservationData.reservation_client_phone_number;
    };

    // 탈거+시공 동시 진행: 탈거 1건 + 시공 1건 별도 생성 (결제 동시 미지원)
    if (withRemoval) {
      const removalSendData = {
        account_ID: customerData.account_ID,
        account_name: customerData.account_name,
        customer_name: customerData.customer_name,
        reservation_division: reservationData.reservation_division,
        reservation_with_removal: 1,
        reservation_high_status: reservationData.reservation_high_status,
        reservation_selected_product: reservationData.selected_product,
        install_selected_product: reservationData.install_selected_product,
        reservation_total_price: totalPrice,
        reservation_customer_ablack_rate: customerData.customer_ablack_rate,
        reservation_customer_address_3: reservationData.postcode_3,
        reservation_customer_address_4: reservationData.postcode_4,
        reservation_customer_ID: customerData.customer_ID,
        reservation_direct_contact_manager: reservationData.reservation_direct_contact_manager,
        reservation_phone_number: phone_number,
        product_consumption_status: reservationData.product_consumption_status,
        construction_reservation_expected_date: reservationData.construction_reservation_expected_date,
        reservation_client_name: reservationData.reservation_client_name,
        reservation_client_particulars: reservationData.reservation_client_particulars,
        reservation_client_request: reservationData.reservation_client_request,
        reservation_date: reservationData.reservation_date,
        reservation_time: reservationData.reservation_time,
        reservation_square_meter: reservationData.reservation_square_meter,
        reservation_space: reservationData.reservation_space,
        // 탈거지 정보
        removal_address: reservationData.postcode_3,
        removal_reservation_date: reservationData.reservation_date,
        removal_reservation_time: reservationData.reservation_time,
        // 시공지 정보
        install_address: reservationData.install_postcode,
        install_reservation_date: reservationData.install_reservation_date,
        install_reservation_time: reservationData.install_reservation_time,
      };
      const removalPushData = handleRemovalPushData(phone_number);
      insert_reservation_with_removal(removalSendData, exPhotoList, directPhotoList, removalPushData).then(result => {
        dispatch(reduxOffSpinner());
        if (result === 1) {
          update_nav();
          dispatch(reduxResetReservation());
          navigate('/reservation_success');
        } else {
          alert('예약 처리 중 오류가 발생했습니다.');
        }
      }).catch(error => {
        dispatch(reduxOffSpinner());
        console.error('Reservation error:', error);
        alert('예약 처리 중 오류가 발생했습니다.');
      });
      return;
    }

    const sendData = {
      account_ID: customerData.account_ID,
      account_name: customerData.account_name,
      customer_name: customerData.customer_name,
      reservation_division: reservationData.reservation_division,
      reservation_with_removal: reservationData.reservation_with_removal,
      reservation_high_status: reservationData.reservation_high_status,
      reservation_selected_product: reservationData.selected_product,
      reservation_total_price: totalPrice,
      reservation_customer_ablack_rate: customerData.customer_ablack_rate,
      reservation_customer_address_3: reservationData.postcode_3,
      reservation_customer_address_4: reservationData.postcode_4,
      reservation_customer_ID: customerData.customer_ID,
      reservation_direct_contact_manager: reservationData.reservation_direct_contact_manager,
      reservation_phone_number: phone_number,
      product_consumption_status: reservationData.product_consumption_status,
      construction_reservation_expected_date: reservationData.construction_reservation_expected_date,
      reservation_client_name: reservationData.reservation_client_name,
      reservation_client_particulars: reservationData.reservation_client_particulars,
      reservation_client_request: reservationData.reservation_client_request,
      reservation_date: reservationData.reservation_date,
      reservation_time: reservationData.reservation_time,
      reservation_square_meter: reservationData.reservation_square_meter,
      reservation_space: reservationData.reservation_space,
      // 결제 동시 처리 플래그
      process_payment: true,
      payment_amount: totalPrice
    };
    const pushData = handlePushData(phone_number);
    insert_reservation(sendData, exPhotoList, directPhotoList, pushData).then(result => {
      dispatch(reduxOffSpinner());

      // 새로운 응답 형식 처리
      if (result && typeof result === 'object' && result.success === 1) {
        update_nav();
        dispatch(reduxResetReservation());
        navigate('/payment_success', { state: result.construction_reservation_ID_list });
      } else if (result === 1) {
        // 기존 응답 형식 (하위 호환)
        update_nav();
        dispatch(reduxResetReservation());
        navigate('/reservation_success');
      } else if (result && result.error) {
        // 에러 처리
        switch (result.error) {
          case 'INSUFFICIENT_POINTS':
            alert(`AP가 부족합니다.\n현재 보유: ${Number(customerData.customer_point).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}AP`);
            break;
          case 'BALANCE_CHECK_FAILED':
          case 'POINT_DEDUCTION_FAILED':
            alert('결제 처리 중 오류가 발생했습니다.\n잠시 후 다시 시도해주세요.');
            break;
          case 'RESERVATION_INSERT_FAILED':
            alert('예약 등록 중 오류가 발생했습니다.\n고객센터에 문의해주세요.');
            break;
          case 'NETWORK_ERROR':
            alert('네트워크 오류가 발생했습니다.\n인터넷 연결을 확인해주세요.');
            break;
          default:
            alert('알 수 없는 오류가 발생했습니다.\n고객센터에 문의해주세요.');
        }
      } else {
        alert('예약 처리 중 오류가 발생했습니다.');
      }
    }).catch(error => {
      dispatch(reduxOffSpinner());
      console.error('Reservation error:', error);
      alert('예약 처리 중 오류가 발생했습니다.');
    });
  };

  const getProductConsumptionStatusLabel = () => {
    switch (reservationData.product_consumption_status) {
      case 0 : return '제품소지';
      case 1 : return `제품 미소지 (제품 도착 예정일: ${reservationData.construction_reservation_expected_date})`;
      case 2 : return '앰비언스 출고요청';
      case 3 : return '출고완료';
      default : return '미등록';
    }
  };

  // B2B 카카오봇 데이터
  const handlePushData = (phone_number: string) => {
    let division_label = '';
    let time_label = '';
    switch (reservationData.reservation_division) {
      case 1 : division_label = '시공'; break;
      case 2 : division_label = 'A/S'; break;
      case 3 : division_label = '이전설치'; break;
      case 4 : division_label = '탈거'; break;
      default : division_label = '미등록'; break;
    };
    if (reservationData.reservation_division === 1 && reservationData.reservation_with_removal === 1) {
      division_label = '시공 (탈거 동시 진행)';
    }
    switch (reservationData.reservation_time) {
      case 1 : time_label = '오전'; break;
      case 2 : time_label = '오후'; break;
      case 3 : time_label = '종일'; break;
      default : time_label = '미등록'; break;
    };
    return `채널세부명: ${customerData.account_name}
고객명: ${reservationData.reservation_client_name}
${installerCheck ? "담당자연락처:" : "고객연락처:"} ${phone_number}
예약구분: ${division_label}
예약일자: ${reservationData.reservation_date} (${time_label})
지역: ${reservationData.postcode_3.address + reservationData.postcode_3.detail_address} ${reservationData.reservation_division === 3 ? `-> ${reservationData.postcode_4.address + reservationData.postcode_4.detail_address}` : ''}
${reservationData.reservation_division === 1 ? `* ${getProductConsumptionStatusLabel()}` : ""}
`;
  }

  const getPushProductLabel = (item: (typeof reservationData.selected_product)[number]) =>
    Number(item.construction_ID) > 0 ? item.product_name : `${item.brand_kor_name} - ${item.product_name}`;

  // 탈거+시공 동시 진행 카카오봇 데이터 (탈거 + 시공 두 건 내용)
  const handleRemovalPushData = (phone_number: string) => {
    let removal_time_label = '';
    let install_time_label = '';
    switch (reservationData.reservation_time) {
      case 1 : removal_time_label = '오전'; break;
      case 2 : removal_time_label = '오후'; break;
      case 3 : removal_time_label = '종일'; break;
      default : removal_time_label = '미등록'; break;
    };
    switch (reservationData.install_reservation_time) {
      case 1 : install_time_label = '오전'; break;
      case 2 : install_time_label = '오후'; break;
      case 3 : install_time_label = '종일'; break;
      default : install_time_label = '미등록'; break;
    };
    return `채널세부명: ${customerData.account_name}
고객명: ${reservationData.reservation_client_name}
${installerCheck ? "담당자연락처:" : "고객연락처:"} ${phone_number}
예약구분: 탈거 + 시공
[탈거] 예약일자: ${reservationData.reservation_date} (${removal_time_label})
[탈거] 지역: ${reservationData.postcode_3.address + reservationData.postcode_3.detail_address}
[탈거] 제품: ${reservationData.selected_product.map(item => `${getPushProductLabel(item)} x${item.quantity}`).join(', ')}
[시공] 예약일자: ${reservationData.install_reservation_date} (${install_time_label})
[시공] 지역: ${reservationData.install_postcode.address + reservationData.install_postcode.detail_address}
[시공] 제품: ${reservationData.install_selected_product.map(item => `${getPushProductLabel(item)} x${item.quantity}`).join(', ')}
[시공] 제품 상태: ${getProductConsumptionStatusLabel()}
`;
  }

  return (
    <S.SectionContainer>
      {showReservationReview ?
        <S.SectionWidth $width={1080}>
          <S.SectionTitleBox>
            <h1>서비스 예약하기</h1>
            <h3>
              A.Black 서비스를 이용하기 전 간편하게 견적을 확인하실 수 있습니다. <br />
              빠른 견적 계산을 위해 A.Black 서비스에 등록된 브랜드와 제품만 견적 확인 가능합니다.
            </h3>
          </S.SectionTitleBox>
          <br />

          {/* 에약 확인 */}
          {withRemoval && <h4 className="text-left font-bold mb-2">탈거할 제품</h4>}
          {reservationData.selected_product.map((tmp, index) =>
            <S.SectionBorderContainer key={`${tmp.product_ID}-${index}`}>
              <div className="content-line">
                <div className="label-box">브랜드</div>
                <div className="content-box">
                  {tmp.brand_kor_name}
                </div>
              </div>
              <hr />
              <div className="content-line">
                <div className="label-box">제품명</div>
                <div className="content-box">{tmp.product_name}</div>
              </div>
              <hr />
              <div className="content-line">
                <div className="label-box">수량</div>
                <div className="content-box">{tmp.quantity}개</div>
              </div>
            </S.SectionBorderContainer>
          )}
          {withRemoval &&
            <>
              <h4 className="text-left font-bold mb-2">{reservationData.product_consumption_status === 2 ? '시공할 제품 (앰비언스 출고요청)' : '시공할 제품'}</h4>
              {reservationData.install_selected_product.map((tmp, index) =>
                <S.SectionBorderContainer key={`${tmp.product_ID}-${index}`}>
                  <div className="content-line">
                    <div className="label-box">브랜드</div>
                    <div className="content-box">
                      {tmp.brand_kor_name}
                    </div>
                  </div>
                  <hr />
                  <div className="content-line">
                    <div className="label-box">제품명</div>
                    <div className="content-box">{tmp.product_name}</div>
                  </div>
                  <hr />
                  <div className="content-line">
                    <div className="label-box">수량</div>
                    <div className="content-box">{tmp.quantity}개</div>
                  </div>
                </S.SectionBorderContainer>
              )}
            </>
          }
          <br />
          <S.SectionBorderContainer>
            <div className="content-line">
              <div className="label-box">천장높이</div>
              <div className="content-box">
                {reservationData.reservation_high_status === 1 && "2.2m 이상 ~ 4m 미만"}
                {reservationData.reservation_high_status === 4 && "2.2m 이상 ~ 2.8m 미만"}
                {reservationData.reservation_high_status === 5 && "2.8m 이상 ~ 4m 미만"}
                {reservationData.reservation_high_status === 2 && "4m 이상 ~ 6m 미만"}
                {reservationData.reservation_high_status === 3 && "6m 초과"}
              </div>
            </div>
            <hr />
            <div className="content-line">
              <div className="label-box">고객명</div>
              <div className="content-box">
                <p>{reservationData.reservation_client_name}</p>
              </div>
            </div>
            <hr />
            {!withRemoval &&
              <>
                <div className="content-line">
                  <div className="label-box">주소</div>
                  <div className="content-box">
                    <p>{reservationData.postcode_3.address}</p>
                    <p className="mt-1">{reservationData.postcode_3.detail_address}</p>
                  </div>
                </div>
                <hr />
              </>
            }
            {reservationData.reservation_division === 3 &&
              <>
                <div className="content-line">
                  <div className="label-box">이전할주소</div>
                  <div className="content-box">
                    <p>{reservationData.postcode_4.address}</p>
                    <p className="mt-1">{reservationData.postcode_4.detail_address}</p>
                  </div>
                </div>
                <hr />
              </>
            }
            <div className="content-line">
              <div className="label-box">전화번호</div>
              <div className="content-box">
                <p>{
                  reservationData.reservation_direct_contact_manager ?
                    reservationData.reservation_manager_phone_number :
                    reservationData.reservation_client_phone_number
                }</p>
              </div>
            </div>
            <hr />
            <div className="content-line">
              <div className="label-box">요청사항</div>
              <div className="content-box">
                <div className="request-item">{reservationData.reservation_client_request}</div>
              </div>
            </div>
            <hr />
            <div className="content-line">
              <div className="label-box">구분</div>
              <div className="content-box">
                {reservationData.reservation_division === 1 && "시공"}
                {reservationData.reservation_division === 2 && "A/S"}
                {reservationData.reservation_division === 3 && "이동 시공"}
                {reservationData.reservation_division === 4 && (withRemoval ? "탈거+시공" : "탈거")}
              </div>
            </div>
            <hr />
            <div className="content-line">
              <div className="label-box">전체 평수</div>
              <div className="content-box">
                {Number(reservationData.reservation_square_meter) === 0 && "미등록"}
                {Number(reservationData.reservation_square_meter) === 1 && "10평 미만"}
                {Number(reservationData.reservation_square_meter) === 2 && "10평 이상 ~ 20평 미만"}
                {Number(reservationData.reservation_square_meter) === 3 && "20평 이상 ~ 30평 미만"}
                {Number(reservationData.reservation_square_meter) === 4 && "30평 이상 ~ 40평 미만"}
                {Number(reservationData.reservation_square_meter) === 5 && "40평 이상 ~ 50평 미만"}
                {Number(reservationData.reservation_square_meter) === 6 && "50평 이상 ~ 60평 미만"}
                {Number(reservationData.reservation_square_meter) === 7 && "60평 이상 ~ 70평 미만"}
                {Number(reservationData.reservation_square_meter) === 8 && "70평 이상 ~ 80평 미만"}
                {Number(reservationData.reservation_square_meter) === 9 && "80평 이상 ~ 90평 미만"}
                {Number(reservationData.reservation_square_meter) === 10 && "90평 이상 ~ 100평 미만"}
                {Number(reservationData.reservation_square_meter) === 11 && "100평 이상"}
              </div>
            </div>
            <hr />
            <div className="content-line">
              <div className="label-box">설치 장소</div>
              <div className="content-box">
                {Number(reservationData.reservation_space) === 0 && "미등록"}
                {Number(reservationData.reservation_space) === 1 && "거실"}
                {Number(reservationData.reservation_space) === 2 && "주방 / 다이닝룸"}
                {Number(reservationData.reservation_space) === 3 && "침실"}
                {Number(reservationData.reservation_space) === 4 && "욕실"}
                {Number(reservationData.reservation_space) === 5 && "서재 / 공부방"}
                {Number(reservationData.reservation_space) === 6 && "아이방"}
                {Number(reservationData.reservation_space) === 7 && "베란다 / 발코니"}
                {Number(reservationData.reservation_space) === 8 && "다용도실"}
                {Number(reservationData.reservation_space) === 9 && "실외"}
                {Number(reservationData.reservation_space) === 10 && "기타"}
              </div>
            </div>
            {!withRemoval &&
              <>
                <hr />
                <div className="content-line">
                  <div className="label-box">시공시간</div>
                  <div className="content-box">
                    <span>{reservationData.reservation_date}</span>
                    <span className="pl-1">
                      {reservationData.reservation_time === 1 && "오전"}
                      {reservationData.reservation_time === 2 && "오후"}
                      {reservationData.reservation_time === 3 && "종일"}
                    </span>
                  </div>
                </div>
              </>
            }
            {withRemoval ?
              <>
                <hr />
                <div className="content-line">
                  <div className="label-box">탈거지 주소</div>
                  <div className="content-box">
                    <p>{reservationData.postcode_3.address}</p>
                    <p className="mt-1">{reservationData.postcode_3.detail_address}</p>
                  </div>
                </div>
                <hr />
                <div className="content-line">
                  <div className="label-box">탈거 희망일</div>
                  <div className="content-box">
                    <span>{reservationData.reservation_date}</span>
                  </div>
                </div>
                <hr />
                <div className="content-line">
                  <div className="label-box">시공지 주소</div>
                  <div className="content-box">
                    <p>{reservationData.install_postcode.address}</p>
                    <p className="mt-1">{reservationData.install_postcode.detail_address}</p>
                  </div>
                </div>
                <hr />
                <div className="content-line">
                  <div className="label-box">시공 희망일</div>
                  <div className="content-box">
                    <span>{reservationData.install_reservation_date}</span>
                  </div>
                </div>
              </>
              :
              <>
                <hr />
                <div className="content-line">
                  <div className="label-box">예상견적</div>
                  <div className="content-box">{renderTotalPrice}AP</div>
                </div>
                <hr />
                <div className="content-line">
                  <div className="label-box">보유 AP</div>
                  <div className="content-box">{Number(customerData.customer_point).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}AP</div>
                </div>
                <hr />
                <div className="content-line">
                  <div className="label-box">결제 후 잔액</div>
                  <div className="content-box">
                    {(Number(customerData.customer_point) - totalPrice).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}AP
                  </div>
                </div>
              </>
            }
          </S.SectionBorderContainer>

          <U.BreakLine $height={20} />

          <S.SectionContent className="flex !justify-center">
            <div className="flex gap-3">
              <S.EmptyRoundedButton 
                onClick={() => setShowReservationReview(false)} 
                $width={240} 
                $btnSelect={false}
                style={{ backgroundColor: "#E5E7EB", color: "#000" }}
              >
                수정하기
              </S.EmptyRoundedButton>
              <S.EmptyRoundedButton
                onClick={() => {
                  setModal(true);
                }}
                $width={240}
                $btnSelect={true}
                style={{ backgroundColor: mainBlack, color: mainWhite }}
              >
                {withRemoval ? "예약하기" : "예약 및 결제하기"}
              </S.EmptyRoundedButton>
            </div>
          </S.SectionContent>

          <U.BreakLine $height={30} />

          {modal &&
                <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 z-50 flex justify-center items-center">
                    <div className="flex flex-col relative bg-mainWhite rounded-lg p-8 w-[500px] h-[300px] mx-auto my-auto">

                        <div className="flex-1 flex flex-col justify-center">
                          {withRemoval ?
                            <div className="mb-6">
                              <p className="text-base leading-relaxed mb-4">
                                <span className="font-bold">탈거 예약 1건과 시공 예약 1건이 함께 접수됩니다.</span>
                              </p>
                              <ul className="text-sm text-gray-600 mb-4 space-y-2">
                                <li>- 예약이 완료되면 담당 시공 인스톨러에게 정보가 전달됩니다.</li>
                                <li>- 제품 출고 이후 해피콜을 통해 시공 일정이 조정됩니다.</li>
                                <li>- 본 예약은 즉시 결제 없이 접수됩니다.</li>
                              </ul>
                            </div>
                            :
                            <div className="mb-6">
                              <p className="text-base leading-relaxed mb-4">
                                예약 완료 시 <span className="font-bold">{renderTotalPrice}AP가 즉시 결제됩니다.</span>
                              </p>
                              <ul className="text-sm text-gray-600 mb-4 space-y-2">
                                <li>- 결제가 완료되면 담당 시공 인스톨러에게 정보가 전달됩니다.</li>
                                <li>- 제품 출고 이후 해피콜을 통해 시공 일정이 조정됩니다.</li>
                                <li>- 현재 보유 AP: {Number(customerData.customer_point).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}AP</li>
                                <li>- 결제 후 잔액: {(Number(customerData.customer_point) - totalPrice).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}AP</li>
                              </ul>
                            </div>
                          }

                          <div className="flex items-start cursor-pointer" onClick={() => setConstructionAgreement(!constructionAgreement)}>
                            <input 
                              type="checkbox" 
                              checked={constructionAgreement} 
                              onChange={() => setConstructionAgreement(!constructionAgreement)}
                              className="accent-pointYellow cursor-pointer mt-1 mr-3"
                            />
                            <span className="text-sm">위 내용을 확인했으며 동의합니다.</span>
                          </div>
                        </div>

                        <div className="flex gap-3 mt-6">
                          <S.EmptyRoundedButton 
                            onClick={() => {
                              setModal(false);
                              setConstructionAgreement(false);
                            }} 
                            $width={240} 
                            $btnSelect={false}
                            style={{ backgroundColor: "#E5E7EB", color: "#000" }}
                          >
                            취소
                          </S.EmptyRoundedButton>
                          <S.EmptyRoundedButton 
                            onClick={() => {
                              if (constructionAgreement) {
                                insertReservation();
                                setModal(false);
                                setConstructionAgreement(false);
                              }
                            }} 
                            $width={240}
                            $btnSelect={constructionAgreement}
                            disabled={!constructionAgreement}
                            style={{
                              backgroundColor: constructionAgreement ? mainBlack : "#E5E7EB",
                              color: constructionAgreement ? mainWhite : "#9CA3AF",
                              cursor: constructionAgreement ? "pointer" : "not-allowed"
                            }}
                          >
                            {withRemoval ? "예약하기" : "예약 및 결제하기"}
                          </S.EmptyRoundedButton>
                        </div>
                    </div>
                </div>
            }

          <U.BreakLine $height={60} />
          
        </S.SectionWidth>

        :

        <S.SectionWidth $width={900}>
          <S.SectionTitleBox>
            <h1>서비스 예약하기</h1>
            <h3>
              A.Black 서비스를 이용하기 전 간편하게 견적을 확인하실 수 있습니다. <br />
              빠른 견적 계산을 위해 A.Black 서비스에 등록된 브랜드와 제품만 견적 확인 가능합니다.
            </h3>
          </S.SectionTitleBox>

          <SelectProductComp step={5} directPhotoList={directPhotoList} setDirectPhotoList={setDirectPhotoList} propsPriceList={propsPriceList} installPriceList={installPriceList} totalPrice={totalPrice} />

          <div className="flex w-[100%] justify-end mt-[-16px] text-sm pr-5 font-light">
            <span>* 본 서비스는 조명의 단순 설치 서비스이므로 이 외 서비스는 추가 비용이 별도로 발생할 수 있습니다.</span>
          </div>
          <U.BreakLine $height={25} />

          <S.SectionContent>
            <div className="section-sub-title-box">
              <h4>서비스 이용 정보 입력</h4>
            </div>
          </S.SectionContent>

          <U.BreakLine $height={30} />

          <S.InputBoxContainer>
            <div className="px-4">
              <div className="grid grid-cols-8 mt-[10px]">
                <div className="col-span-3 font-semibold">
                  <h6>기업 정보</h6>
                </div>
                <div className="col-span-5">
                  <div className="input-flex-box">
                    <S.InputItemBox $inputMinWidth={245}>
                      <div className="flex-grow mb-2">
                        <span>기업 정보</span>
                      </div>
                      <input type="text" value={customerData.customer_name} readOnly className="cursor-default bg-sideMenu" />
                    </S.InputItemBox>
                    <S.InputItemBox $inputMinWidth={245}>
                      <div className="flex-grow w-full mb-2">
                        <span>기업 연락처</span>
                      </div>
                      <input type="text" value={customerData.customer_phone_number} readOnly className="cursor-default bg-sideMenu w-full" />
                    </S.InputItemBox>
                  </div>

                  <div className="input-flex-box">
                    <S.InputItemBox>
                      <div className="flex-grow w-full mb-2">
                        <span>기업 담당자 전화번호</span>
                      </div>
                      <input
                        type="text" placeholder="기업 담당자 전화번호 입력" value={customerManagerPhoneNumber} maxLength={12} disabled={installerCheck ? false : true}
                        className={`${installerCheck ? "" : "bg-sideMenu"} w-full`} readOnly={approveCert ? true : false}
                        onChange={(e) => dispatch(reduxChangeReservationManagerPhoneNumber(removeWhitespacePhone(e.target.value)))}
                      />
                    </S.InputItemBox>
                    <SearchPostButton
                      onClick={() => requestSendMobileMessage()} disabled={installerCheck ? false : true}
                      className={`${approveCert ? "cursor-default" : ""} flex self-end mb-[10px]`}
                    >
                      인증번호 발송
                    </SearchPostButton>
                  </div>
                  <S.InputItemBox>
                    <input
                      onChange={checkCertification} disabled={installerCheck ? false : true}
                      type="text" placeholder="인증번호" className={`${installerCheck ? "" : "bg-sideMenu"} w-full`}
                      readOnly={approveCert ? true : false} maxLength={6}
                    />
                    {(certificationTimer && installerCheck) &&
                      <h5 className="certification-timer">{rederCountdown}</h5>
                    }
                  </S.InputItemBox>
                  {installerCheck && <p className={`text-sm ${approveCert ? "text-green-500" : "text-red-500"}`}>{noticeCertification}</p>}

                  <S.InputItemBox $inputWidth={13} className="relative cursor-pointer mt-2" onClick={handleInstallerCheck}>
                    <input type="checkbox" checked={installerCheck ? true : false} className="accent-pointYellow cursor-pointer" readOnly />
                    <p className="font-medium text-[13px] text-darkGray inline-block ml-5">기업 담당자를 통해 라이팅 인스톨러(시공기사)와 직접 연락</p>
                    <p className="font-medium text-[13px] text-red-500 block ml-5 mt-1">⚠️ 체크 시 인스톨러가 <span className="font-bold">고객이 아닌 기업 담당자</span>에게 연락합니다.</p>
                    <p className="font-medium text-[13px] text-red-500 block ml-5">현장 고객과 직접 연락이 필요하면 <span className="font-bold">체크하지 마세요.</span></p>
                  </S.InputItemBox>

                  <br />
                </div>
              </div>

              {/* <div className="vertical-line lg:hidden md:hidden"></div> */}

              <div className="grid grid-cols-8 mt-10">
                <div className="col-span-3 font-semibold mb-2">
                  <h6>서비스 이용 고객 정보</h6>
                </div>
                <div className="col-span-5">
                  <S.InputItemBox>
                    <div className="flex-grow w-full mb-2">
                      <span>서비스 이용 고객명</span>
                    </div>
                    <input
                      type="text" value={clientName}
                      onChange={(e) => dispatch(reduxChangeReservationClientName(e.target.value))}
                      className="w-full"
                    />
                  </S.InputItemBox>

                  <div className="input-flex-box">
                    <S.InputItemBox>
                      <div className="flex-grow w-full mb-2">
                        <span>고객 전화번호</span>
                      </div>
                      <input
                        type="text" placeholder="고객 전화번호 입력" value={clientPhoneNumber} maxLength={12} disabled={installerCheck ? true : false}
                        className={`${installerCheck ? "bg-sideMenu" : ""} w-full`} readOnly={approveCert ? true : false}
                        onChange={(e) => dispatch(reduxChangeReservationClientPhoneNumber(removeWhitespacePhone(e.target.value)))}
                      />
                    </S.InputItemBox>
                    <SearchPostButton
                      onClick={() => requestSendMobileMessage()} disabled={installerCheck ? true : false}
                      className={`${approveCert ? "cursor-default" : ""} flex self-end mb-[10px]`}
                    >
                      인증번호 발송
                    </SearchPostButton>
                  </div>
                  <S.InputItemBox>
                    <input
                      onChange={checkCertification} disabled={installerCheck ? true : false}
                      type="text" placeholder="인증번호" className={`${installerCheck ? "bg-sideMenu" : ""} w-full`}
                      readOnly={approveCert ? true : false} maxLength={6}
                    />
                    {(certificationTimer && !installerCheck) &&
                      <h5 className="certification-timer">{rederCountdown}</h5>
                    }
                  </S.InputItemBox>
                  {installerCheck || <p className={`text-sm ${approveCert ? "text-green-500" : "text-red-500"}`}>{noticeCertification}</p>}


                  <S.InputItemBox>
                    <div className="flex-grow w-full mb-2">
                      <span className="">{withRemoval ? "탈거지 주소" : "고객 주소"}</span>
                    </div>
                    <span className="alert-text-new-line">
                      {`*${availableAreasWithinWeek.join(', ')} 외 지역은 최소 ${MIN_DAYS_OTHER_AREA}일 이후부터 시공 희망일을 선택 하실 수 있습니다.`}
                    </span>
                  </S.InputItemBox>
                  <div className="input-flex-box">
                    <DaumPostCode addressSelect={3} />
                  </div>

                  {reservationData.reservation_division === 3 &&
                    <>
                      <S.InputItemBox style={{ marginTop: "-8px" }}>
                        <div className="flex-grow w-full mb-2">
                          <span className="mt-[-8px] mb-[-14px]">이전할 주소</span>
                        </div>
                      </S.InputItemBox>
                      <div className="input-flex-box">
                        <DaumPostCode addressSelect={4} />
                      </div>
                    </>
                  }

                  {withRemoval &&
                    <>
                      <S.InputItemBox $inputWidth={13} className="relative cursor-pointer mt-2 mb-6" onClick={() => {
                        if (sameAsRemoval) {
                          setSameAsRemoval(false);
                        } else {
                          dispatch(reduxChangeInstallPostcode({ ...reservationData.postcode_3 }));
                          setSameAsRemoval(true);
                        }
                      }}>
                        <input type="checkbox" checked={sameAsRemoval} className="accent-pointYellow cursor-pointer" readOnly />
                        <p className="font-medium text-[13px] text-darkGray inline-block ml-5">시공지 주소 탈거지와 동일</p>
                      </S.InputItemBox>
                      <S.InputItemBox>
                        <div className="flex-grow w-full mb-2">
                          <span>시공지 주소</span>
                        </div>
                        <span className="alert-text-new-line">
                          {`*${availableAreasWithinWeek.join(', ')} 외 지역은 최소 ${MIN_DAYS_OTHER_AREA}일 이후부터 시공 희망일을 선택 하실 수 있습니다.`}
                        </span>
                      </S.InputItemBox>
                      <div className="input-flex-box">
                        <DaumPostCode addressSelect={5} />
                      </div>
                    </>
                  }
                  <S.InputItemBox className="mt-[-10px] w-full">
                    <div className="mb-2">
                      <span>전체 평수</span>
                    </div>
                    <select
                      className={`w-full ${squareMeter ? "text-[16px] text-mainBlack" : "text-[14px] text-middleGray02"}`}
                      value={squareMeter}
                      onChange={(e) => {
                        dispatch(reduxChangeReservationSquareMeter(e.target.value));
                      }}
                    >
                      <option value={0} disabled>전체 평수 선택</option>
                      <option value={1}>10평 미만</option>
                      <option value={2}>10평 이상 ~ 20평 미만</option>
                      <option value={3}>20평 이상 ~ 30평 미만</option>
                      <option value={4}>30평 이상 ~ 40평 미만</option>
                      <option value={5}>40평 이상 ~ 50평 미만</option>
                      <option value={6}>50평 이상 ~ 60평 미만</option>
                      <option value={7}>60평 이상 ~ 70평 미만</option>
                      <option value={8}>70평 이상 ~ 80평 미만</option>
                      <option value={9}>80평 이상 ~ 90평 미만</option>
                      <option value={10}>90평 이상 ~ 100평 미만</option>
                      <option value={11}>100평 이상</option>
                    </select>
                  </S.InputItemBox>
                  <S.InputItemBox className="mt-4 w-full">
                    <div className="flex-grow w-full mb-2">
                      <span>설치장소</span>
                    </div>
                    <select
                      className={`w-full ${space ? "text-[16px] text-mainBlack" : "text-[14px] text-middleGray02"}`}
                      value={space}
                      onChange={(e) => {
                        dispatch(reduxChangeReservationSpace(e.target.value));
                      }}
                    >
                      <option value={0} disabled>설치장소 선택</option>
                      <option value={1}>거실</option>
                      <option value={2}>주방 / 다이닝룸</option>
                      <option value={3}>침실</option>
                      <option value={4}>욕실</option>
                      <option value={5}>서재 / 공부방</option>
                      <option value={6}>아이방</option>
                      <option value={7}>베란다 / 발코니</option>
                      <option value={8}>다용도실</option>
                      <option value={9}>실외</option>
                      <option value={10}>기타</option>
                    </select>
                  </S.InputItemBox>

                  {/* <S.InputItemBox $inputWidth={0} style={{ marginTop: "-12px" }}>
                    <div className="flex-grow w-full">
                      <span>고객 특이사항</span>
                    </div>
                    <textarea
                      rows={6} placeholder="고객의 특이사항 입력" value={clientParticulars} maxLength={500}
                      onChange={(e) => dispatch(reduxChangeReservationClientParticulars(e.target.value))}
                    ></textarea>
                    <div className="length-box">
                      <span>{clientParticulars.length}</span>&nbsp;
                      <span>/ 500</span>
                    </div>
                  </S.InputItemBox> */}

                  <S.InputItemBox className="mt-3">
                    <div className="flex-grow w-full mb-2">
                      <span>요청사항</span>
                      {clientRequest.length < 20 && <span className="alert-text"> -20자 이상 작성해주세요.</span>}
                    </div>
                    <textarea
                      rows={6} placeholder={`천장높이, 이동시공, 인테리어 여부 필수 입력 \n이 외의 추가요청 사항을 입력해주세요.`} value={clientRequest}
                      onChange={(e) => dispatch(reduxChangeReservationClientRequest(e.target.value))} maxLength={500}
                      className="w-full text-base"
                    ></textarea>
                    <div className="length-box">
                      <span>{clientRequest.length}</span>&nbsp;
                      <span>/ 500</span>
                    </div>
                  </S.InputItemBox>

                  <S.InputItemBox className="mt-[12px]">
                    <div className="flex-grow w-full mb-2">
                      <span>현장 사진 (최대 4장까지 가능)</span>
                      {exPhotoList.length < 2 && <span className="alert-text"> -현장사진을 2장 이상 추가해주세요.</span>}
                    </div>
                    <S.PhotoBox $gridColumn={4}>
                      {exPhotoList[0] ?
                        <div className="prev-item" onClick={() => removeFile(0)}>
                          <img className="prev-img" src={exPreviewList[0]} alt="" />
                          <div className="prev-hover">삭제</div>
                        </div>
                        :
                        <div>
                          <input type="file" id="ex_photo_1" name='general_photo_list' accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={insertFile} />
                          <label htmlFor="ex_photo_1">
                            <div className="photo-item">+</div>
                          </label>
                        </div>
                      }
                      {exPhotoList[1] ?
                        <div className="prev-item" onClick={() => removeFile(1)}>
                          <img className="prev-img" src={exPreviewList[1]} alt="" />
                          <div className="prev-hover">삭제</div>
                        </div>
                        :
                        <div>
                          <input type="file" id="ex_photo_2" name='general_photo_list' accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={insertFile} />
                          <label htmlFor="ex_photo_2">
                            <div className="photo-item">+</div>
                          </label>
                        </div>
                      }
                      {exPhotoList[2] ?
                        <div className="prev-item" onClick={() => removeFile(2)}>
                          <img className="prev-img" src={exPreviewList[2]} alt="" />
                          <div className="prev-hover">삭제</div>
                        </div>
                        :
                        <div>
                          <input type="file" id="ex_photo_3" name='general_photo_list' accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={insertFile} />
                          <label htmlFor="ex_photo_3">
                            <div className="photo-item">+</div>
                          </label>
                        </div>
                      }
                      {exPhotoList[3] ?
                        <div className="prev-item" onClick={() => removeFile(3)}>
                          <img className="prev-img" src={exPreviewList[3]} alt="" />
                          <div className="prev-hover">삭제</div>
                        </div>
                        :
                        <div>
                          <input type="file" id="ex_photo_4" name='general_photo_list' accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={insertFile} />
                          <label htmlFor="ex_photo_4">
                            <div className="photo-item">+</div>
                          </label>
                        </div>
                      }
                    </S.PhotoBox>
                  </S.InputItemBox>
                </div>
              </div>
            </div>
          </S.InputBoxContainer>

          <U.BreakLine $height={60}>
            <div className="horizontal-05-blk"></div>
          </U.BreakLine>

          <S.SectionContent>
            <div>
              <div className="section-sub-title-box flex">
                <h4>{withRemoval ? "탈거 희망일자 선택" : "시공 희망일자 선택"}</h4>
              </div>
              <div
                className="text-red-500 text-sm font-semibold mt-2 flex"
              >
                <span>시공 희망일자는 고객님께서 희망하는 날짜를 미리 선택하는 사전 단계입니다.<br />실제 시공일은 시공 인스톨러와 고객님 간의 일정 조율 관련 소통 이후 확정된 일정으로 진행됩니다.</span>
              </div>
            </div>
          </S.SectionContent>

          <U.BreakLine $height={30} />

          <S.InputBoxContainer>
            <S.InputItemBox className="flex justify-center gap-6">
              <div className="flex flex-col gap-2 flex-1 min-w-[250px] max-w-[280px]">
                <div className="mb-2">
                  <label>{withRemoval ? "탈거 희망 날짜" : "시공 희망 날짜"}</label>
                </div>
                  <input
                    type="date"
                    className="w-full"
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      const disabledDates = ablackHolidayList;
                      if (disabledDates.includes(selectedDate)) {
                        alert('선택한 날짜는 예약할 수 없습니다.');
                          e.target.value = '';
                          e.target.style.backgroundColor = 'transparent';
                      } else {
                          dispatch(reduxChangeReservationDate(selectedDate));
                      }
                    }}
                    value={clientScheduledDate}
                    max={availableMaximumDate}
                    min={availableMinimumDate}
                  />
              </div>
              <div onClick={handleReservationTime} className="flex flex-col gap-2">
                <div className="mb-2">
                  <span>시간대 선택</span>
                </div>
                <div className="flex gap-2">
                  <S.EmptyRoundedButton data-value={1} $width={165} $btnSelect={clientReservationTime === 1 ? true : false}>오전</S.EmptyRoundedButton>
                  <S.EmptyRoundedButton data-value={2} $width={165} $btnSelect={clientReservationTime === 2 ? true : false}>오후</S.EmptyRoundedButton>
                  <S.EmptyRoundedButton data-value={3} $width={165} $btnSelect={clientReservationTime === 3 ? true : false}>종일</S.EmptyRoundedButton>
                </div>
              </div>
            </S.InputItemBox>
          </S.InputBoxContainer>

          {withRemoval &&
            <>
              <U.BreakLine $height={30} />

              <S.SectionContent>
                <div>
                  <div className="section-sub-title-box flex">
                    <h4>시공 희망일자 선택</h4>
                  </div>
                  <div
                    className="text-red-500 text-sm font-semibold mt-2 flex"
                  >
                    <span>시공 희망일자는 고객님께서 희망하는 날짜를 미리 선택하는 사전 단계입니다.<br />실제 시공일은 시공 인스톨러와 고객님 간의 일정 조율 관련 소통 이후 확정된 일정으로 진행됩니다.</span>
                  </div>
                </div>
              </S.SectionContent>

              <U.BreakLine $height={30} />

              <S.InputBoxContainer>
                <S.InputItemBox className="flex justify-center gap-6">
                  <div className="flex flex-col gap-2 flex-1 min-w-[250px] max-w-[280px]">
                    <div className="mb-2">
                      <label>시공 희망 날짜</label>
                    </div>
                      <input
                        type="date"
                        className="w-full"
                        onChange={(e) => {
                          const selectedDate = e.target.value;
                          const disabledDates = ablackHolidayList;
                          if (disabledDates.includes(selectedDate)) {
                            alert('선택한 날짜는 예약할 수 없습니다.');
                              e.target.value = '';
                              e.target.style.backgroundColor = 'transparent';
                          } else {
                              dispatch(reduxChangeInstallReservationDate(selectedDate));
                          }
                        }}
                        value={reservationData.install_reservation_date}
                        max={availableInstallMaximumDate}
                        min={availableInstallMinimumDate}
                      />
                  </div>
                  <div onClick={handleInstallReservationTime} className="flex flex-col gap-2">
                    <div className="mb-2">
                      <span>시간대 선택</span>
                    </div>
                    <div className="flex gap-2">
                      <S.EmptyRoundedButton data-value={1} $width={165} $btnSelect={reservationData.install_reservation_time === 1 ? true : false}>오전</S.EmptyRoundedButton>
                      <S.EmptyRoundedButton data-value={2} $width={165} $btnSelect={reservationData.install_reservation_time === 2 ? true : false}>오후</S.EmptyRoundedButton>
                      <S.EmptyRoundedButton data-value={3} $width={165} $btnSelect={reservationData.install_reservation_time === 3 ? true : false}>종일</S.EmptyRoundedButton>
                    </div>
                  </div>
                </S.InputItemBox>
              </S.InputBoxContainer>
            </>
          }

          <U.BreakLine $height={30}>
          </U.BreakLine>

          <S.SectionContent>
            <div className="mx-auto">
              <S.EmptyRoundedButton onClick={() => handleCheckReservation()} $width={250} $btnSelect={false} style={{ backgroundColor: mainBlack, color: mainWhite }}>
                예약내용 확인
              </S.EmptyRoundedButton>
            </div>
          </S.SectionContent>

          <U.BreakLine $height={60} />

        </S.SectionWidth>
      }
    </S.SectionContainer>
  )
};

export default Reservation;